import type { SerializedError } from "@reduxjs/toolkit";
import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";

export const getErrorMessage = (
  error: FetchBaseQueryError | SerializedError | undefined
): string => {
  if (!error) return "";

  // Handle FetchBaseQueryError
  if ("status" in error) {
    // Handle HTTP errors
    if (error.status === "FETCH_ERROR") {
      return "Network error. Please check your connection.";
    }

    if (error.status === "PARSING_ERROR") {
      return "Server response error. Please try again.";
    }

    if (error.status === "TIMEOUT_ERROR") {
      return "Request timeout. Please try again.";
    }

    // Handle HTTP status codes
    if (typeof error.status === "number") {
      // Try to extract message from error data
      if (error.data && typeof error.data === "object" && "message" in error.data) {
        return error.data.message as string;
      }

      // Fallback messages for common HTTP status codes
      switch (error.status) {
        case 400:
          return "Invalid request. Please check your input.";
        case 401:
          return "Invalid credentials. Please try again.";
        case 403:
          return "Access denied.";
        case 404:
          return "Service not found.";
        case 429:
          return "Too many requests. Please try again later.";
        case 500:
          return "Server error. Please try again later.";
        default:
          return `Request failed with status ${error.status}`;
      }
    }
  }

  // Handle SerializedError
  if ("message" in error) {
    return error.message || "An unexpected error occurred.";
  }

  return "An unexpected error occurred.";
};
